<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login"
       :style="`background-image: url('/assets/images/pages/login-bg_${appFilename}.jpg')`">

    <vue-recaptcha sitekey="6LdySYogAAAAAG6UezGysaKCLxliUPnSKJtL7Ef0" :loadRecaptchaScript="true" size="invisible"
                   ref="recaptcha"
                   badge="bottomright"
                   @verify="verifyMethod"></vue-recaptcha>

    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img :src="`/assets/images/pages/login_${appFilename}.png`" alt="" class="mx-auto" />
            </div>
            <div class="vx-col sm:block md:block lg:hidden">
              <img :src="`/assets/images/pages/login_${appFilename}.png`" alt="" class="h-48" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <form action @submit="loginSubmit" v-show="!twofactor_active && !email_security_active">
                <div class="p-8">
                  <div class="vx-card__title mb-8 hidden md:block">
                    <h4 class="mb-4">Login {{ appName }}</h4>
                  </div>
                  <vs-input
                    v-validate="'required|email|min:3'"
                    data-vv-validate-on="blur"
                    name="email"
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Email"
                    v-model.trim="email"
                    autocomplete="username"
                    class="w-full no-icon-border"
                  />
                  <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                  <vs-input
                    data-vv-validate-on="blur"
                    v-validate="'required|min:6|max:30'"
                    type="password"
                    name="password"
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Senha"
                    v-model="password"
                    autocomplete="current-password"
                    class="w-full mt-6 no-icon-border"
                  />

                  <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                  <div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Lembrar e-mail</vs-checkbox>
                    <router-link to="/pages/forgot-password">Esqueceu a senha?</router-link>
                  </div>
                  <vs-button type="border" @click="registerUser">Registrar</vs-button>

                  <vs-button class="float-right" :disabled="!validateForm || processing" @click="loginWithRecaptcha">Entrar</vs-button>
                  <button type="submit" style="display: none"></button>
                </div>
              </form>

              <form action @submit="twofactorSubmit" v-show="twofactor_active" class="mb-10">
                <div class="p-8">
                  <div v-show="!use_recovery_code">
                    <div class="vx-card__title mb-8">
                      <h4 class="mb-4">Autenticação em 2 Passos</h4>
                      <p>Abra o aplicativo Google Authenticator e digite os 6 dígitos abaixo.</p>
                    </div>
                    <vs-input
                      name="twofactorcode"
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Código de 6 Dígitos"
                      v-model.trim="twofactor_code"
                      autocomplete="off"
                      class="w-full no-icon-border"
                    />

                    <div class="flex flex-wrap justify-between my-5">
                      <vs-checkbox v-model="twofactor_remember_device" class="mb-3">Salvar dispositivo</vs-checkbox>
                      <a href="javascript:;" @click="twoFactorToggleCode()">Não tenho mais acesso ao celular</a>
                    </div>
                  </div>

                  <div v-show="use_recovery_code">
                    <div class="vx-card__title mb-8">
                      <h4 class="mb-4">Autenticação em 2 Passos</h4>
                      <p>Digite ou cole abaixo seu código de recuperação da autenticação em 2 passos.</p>
                    </div>
                    <vs-input
                      name="twofactorrecovery"
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Código de Recuperação"
                      v-model.trim="twofactor_recovery_code"
                      autocomplete="off"
                      class="w-full no-icon-border uppercase"
                    />

                    <div class="flex flex-wrap justify-between my-5">
                      <vs-checkbox v-model="twofactor_remember_device" class="mb-3">Salvar dispositivo</vs-checkbox>
                      <a href="javascript:;" @click="twoFactorToggleCode()"
                      >Digitar o código ao invés da chave de recuperação</a
                      >
                    </div>
                  </div>

                  <vs-button color="danger" class="float-left" @click="twofactorCancel">Voltar ao Login</vs-button>
                  <vs-button class="float-right" @click="twofactorCheck">Continuar</vs-button>
                  <button type="submit" style="display: none"></button>
                </div>
              </form>

              <form action @submit="emailSecuritySubmit" v-show="email_security_active" class="mb-10">
                <div class="p-8">
                  <div class="vx-card__title mb-8">
                    <h4 class="mb-4">Verificação de Segurança</h4>
                    <p>Não reconhecemos esse dispositivo. Para sua segurança, enviamos um código para o seu e-mail.</p>
                  </div>
                  <vs-input
                    name="emailsecuritycode"
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Digite aqui o código"
                    v-model.trim="email_security_code"
                    autocomplete="off"
                    class="w-full no-icon-border"
                  />

                  <div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox v-model="email_security_remember_device" class="mb-3">Salvar dispositivo</vs-checkbox>
                  </div>

                  <vs-button color="danger" class="float-left" @click="emailSecurityCancel">Voltar ao Login</vs-button>
                  <vs-button class="float-right" @click="emailSecurityCheck">Continuar</vs-button>
                  <button type="submit" style="display: none"></button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'

export default {
  components: {VueRecaptcha},
  data() {
    return {
      email: '',
      password: '',
      checkbox_remember_me: false,
      use_recovery_code: false,
      twofactor_active: false,
      twofactor_code: null,
      twofactor_recovery_code: null,
      twofactor_remember_device: false,
      email_security_active: false,
      email_security_code: null,
      email_security_remember_device: false,
      access_token: null,
      user_id: null,
      appName: process.env.VUE_APP_NAME,
      appFilename: process.env.VUE_APP_FILENAME,
      returnTo: null,
      processing: false,
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email != '' && this.password != ''
    }
  },
  mounted: function () {
    this.$EventBus.$emit('userChanged')
    this.$localStorage.set('userId', '')
    this.$localStorage.set('token', '')
    if (this.$route.query.returnTo) {
      this.returnTo = this.$route.query.returnTo
    }
  },
  methods: {
    login(recaptcha_token) {
      if (!this.validateForm) return false

      this.processing = true;

      const twofactor_device_fingerprint = this.$localStorage.get('twofactorDeviceFingerprint')
      const email_security_device_fingerprint = this.$localStorage.get('emailSecurityDeviceFingerprint')

      this.$api
      .post('/api/v1/auth/login', {
        email: this.email,
        password: this.password,
        web: 1,
        recaptcha_token: recaptcha_token,
        twofactor_device_fingerprint: twofactor_device_fingerprint,
        email_security_device_fingerprint: email_security_device_fingerprint
      })
      .then((response) => {
        if (response.data.twofactor_active && !response.data.access_token) {
          this.twofactor_active = true
        } else if (response.data.email_security_active && !response.data.access_token) {
          this.email_security_active = true
        } else {
          let Tawk_API = Tawk_API || {}
          Tawk_API.visitor = {
            email: this.email
          }

          this.$localStorage.set('token', response.data.access_token)
          this.$localStorage.set('userId', response.data.user_id)
          this.$localStorage.set(
            'userInfo',
            JSON.stringify({
              email: this.email,
              providerId: 'local',
              uid: 1
            })
          )

          this.$EventBus.$emit('userChanged')

          this.$router.push(this.returnTo || '/dispositivo')
        }
      })
      .catch((error) => {
        this.processing = false;
        this.$refs.recaptcha.reset();

        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: error.response.data.error || error.response.data.message || 'Servidor em manutenção, por favor tente novamente em 1 hora.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },

    loginWithRecaptcha() {
      this.$refs.recaptcha.execute();
    },

    loginSubmit(e) {
      e.preventDefault()

      this.loginWithRecaptcha();
    },

    twoFactorToggleCode() {
      this.twofactor_code = null
      this.twofactor_recovery_code = null
      this.use_recovery_code = !this.use_recovery_code
    },

    twofactorCheck() {
      this.$api
      .post('/api/v1/auth/login', {
        email: this.email,
        password: this.password,
        twofactor_code: this.twofactor_code,
        twofactor_recovery_code: this.twofactor_recovery_code,
        twofactor_remember_device: this.twofactor_remember_device,
        web: 1
      })
      .then((response) => {
        if (response.data.twofactor_device_fingerprint) {
          this.$localStorage.set('twofactorDeviceFingerprint', response.data.twofactor_device_fingerprint)
        }

        if (response.data.access_token) {
          this.$localStorage.set('token', response.data.access_token)
          this.$localStorage.set('userId', response.data.user_id)
          this.$localStorage.set(
            'userInfo',
            JSON.stringify({
              email: this.email,
              providerId: 'local',
              uid: 1
            })
          )
          this.$EventBus.$emit('userChanged')
          this.$router.push('/dispositivo')
        }
      })
      .catch((error) => {
        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: error.response.data.error || error.response.data.message || 'Servidor em manutenção, por favor tente novamente em 1 hora.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },

    twofactorSubmit(e) {
      this.twofactorCheck()

      e.preventDefault()
    },

    twofactorCancel() {
      this.twofactor_active = false
    },

    emailSecurityCheck() {
      this.$api
      .post('/api/v1/auth/login', {
        email: this.email,
        password: this.password,
        email_security_code: this.email_security_code,
        email_security_remember_device: this.email_security_remember_device,
        web: 1
      })
      .then((response) => {
        if (response.data.email_security_device_fingerprint) {
          this.$localStorage.set('emailSecurityDeviceFingerprint', response.data.email_security_device_fingerprint)
        }

        if (response.data.access_token) {
          this.$localStorage.set('token', response.data.access_token)
          this.$localStorage.set('userId', response.data.user_id)
          this.$localStorage.set(
            'userInfo',
            JSON.stringify({
              email: this.email,
              providerId: 'local',
              uid: 1
            })
          )
          this.$EventBus.$emit('userChanged')
          this.$router.push('/dispositivo')
        }
      })
      .catch((error) => {
        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: error.response.data.error || error.response.data.message || 'Servidor em manutenção, por favor tente novamente em 1 hora.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },

    emailSecuritySubmit(e) {
      this.emailSecurityCheck()

      e.preventDefault()
    },

    emailSecurityCancel() {
      this.email_security_code = ''
      this.email_security_active = false
    },

    registerUser() {
      this.$router.push('/pages/register')
    },

    verifyMethod(recaptcha_token) {
      this.login(recaptcha_token)
    },
  }
}
</script>
